import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountSettings} from 'src/openapi/admin/apis/GetAccountSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useGetProjectCodesEnabled = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(async (signal: AbortSignal) => {
        const loadedData = await apiDispatch(getAccountSettings({accountId}, {signal}));
        if (loadedData.payload.success) {
            const payload: {success: true, error: false, data: boolean} = {
                success: true,
                error: false,
                data: loadedData.payload.data.projectCodesEnabled,
            };

            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: loadedData.payload});
        }
    }, [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: false,
        getDispatchAction,
    });
};
